<template>
    <div class="inline corner bg-default-l1">
        <a target="_blank"  class="flex middle" :href="data.cpc + utmSource" rel="nofollow" >
            <div class="singleline">
                <div class="text-bold singleline">
                    {{$filters.formatPrice(data.estpayment)}}/mo - APR {{data.apr}}%
                </div>
                <div class="f8 singleline">
                    {{$filters.formatPrice(data.fees)}} initial fee - {{data.rate}}% at {{data.discpoints}} pts
                </div>
            </div>
            <div class="noshrink">
                <div class="f8">
                    <img :src="data.logo" class="img-small" loading="lazy"/>
                    <div v-if="data.NMLS">
                        NMLSID:{{data.NMLS}}
                    </div>
                    <div v-else-if="data.LICENSE">
                        Lender License: {{data.LICENSE}}
                    </div>
                </div>
            </div>
            <div class="btn primary small noshrink" v-if="!data.isPersonal" @click="applyBtn">Next</div>
        </a>
        <span class="f8 singleline" v-if="openMortgage && data.advertiserPLabel">{{ data.advertiserPLabel }}</span>
    </div>

</template>

<script src="./mvt-cardmortgage.js"></script>
